var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var SuccessDialog = require('../common/ok-message-dialog-with-action');
var Radio = require('backbone.radio');

var notificationsChannel = Radio.channel('notifications');

var HelpFeedbackView = Marionette.View.extend({
    template: require('../../templates/help/help-feedback-view.html'),

    ui: {
        name: '#name',
        email: '#email',
        text: '#text',
        send: '#send'
    },

    events: {
        'click @ui.send': 'send',
        'keyup @ui.email': 'validateEmail',
        'change @ui.email': 'validateEmail'
    },

    regions: {
        dialog: '#success-dialog'
    },

    initialize: function (options) {
        _.bindAll(this, 'send', 'validateEmail');
        this.utils = new CommonUtils();
    },

    onRender: function () {
        this.showChildView('dialog', new SuccessDialog({
            title: 'Success',
            message: 'Feedback was sent successfully'
        }));
    },

    validateEmail: function (event) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value)) {
            this.ui.email.parent().removeClass('has-error has-feedback');
            this.ui.email.tooltip("destroy");
            this.ui.send.removeAttr("disabled");
        } else {
            this.ui.email.parent().addClass('has-error has-feedback');
            this.ui.email.tooltip({title: 'Invalid e-mail'});
            this.ui.send.attr("disabled", "true");
        }
    },

    send: function () {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/help/feedback',
            data: {
                name: that.ui.name.val(),
                email: that.ui.email.val(),
                text: that.ui.text.val()
            },
            dataType: 'text',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.getChildView('dialog').show();
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
            }
        });
    }

});


module.exports = HelpFeedbackView;


//////////////////
// WEBPACK FOOTER
// ./app/views/help/help-feedback-view.js
// module id = 511
// module chunks = 0